import PropTypes from 'prop-types';
import { useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Divider,
    Drawer,
    useMediaQuery
} from "@mui/material";

// project import
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import MiniDrawerStyled from './MiniDrawerStyled';
import { APP_URL, drawerWidth } from "config";
import Profile from "../Header/HeaderContent/Profile";
const isCensornet = process.env.REACT_APP_BRAND_TYPE === 'censornet';

import logoSmall from 'assets/images/icons/icon-home-boxphish.svg';
import { useSelector } from "react-redux";
import { Logo100, LogoCn50 } from "../../../components/Logo/Logo";

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

const MainDrawer = ({ open, handleDrawerToggle, window, showBanner }) => {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const matchDownXS = useMediaQuery(theme.breakpoints.down('xs'));
    const { tenancyBasics: tenancyData, tenancyBasicsLoading: tenancyLoading } = useSelector((state) => state.tenancy);

    // responsive drawer container
    const container = window !== undefined ? () => window().document.body : undefined;

    // tenancyBasics is centralized in Redux (fetched once in App.js)
    const tenancyError = null; // Error handling is done in App.js

    // header content
    const drawerHeader = useMemo(() => <DrawerHeader open={open} handleDrawerToggle={handleDrawerToggle} />, [open, handleDrawerToggle]);
    const drawerContent = useMemo(() => <DrawerContent open={open} handleDrawerToggle={handleDrawerToggle} />, [open, handleDrawerToggle]);

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1300 }} aria-label="mailbox folders">
            {!matchDownSM ? (
                <MiniDrawerStyled variant="permanent" open={open} sx={{ '& .MuiDrawer-paper': { top: showBanner ? 'var(--banner-height, 0px)' : 0, height: showBanner ? 'calc(100vh - var(--banner-height, 0px))' : '100vh', transition: 'top 0.3s ease' } }}>
                    {open && drawerHeader}
                    {!open &&
                        <>
                            {!tenancyLoading && !tenancyError && tenancyData && tenancyData.logo ?
                                <img src={`${APP_URL}/${tenancyData.logo}`} alt="Logo" width="48" height="48" style={{ objectFit: "contain", marginTop: 8, alignSelf: 'center' }} /> :
                                <span style={{ marginLeft: 20, marginTop: 20, width:32, height:32 }}>{isCensornet ? <LogoCn50  /> : <Logo100 />}</span>
                            }
                        </>
                    }

                    {drawerContent}

                    { open && <Divider/> }
                    <Profile open={open} />
                </MiniDrawerStyled>
            ) : (
                <>
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={open}
                        onClose={handleDrawerToggle}
                        ModalProps={{ keepMounted: true }}
                        sx={{
                            display: { xs: 'block', lg: 'none' },
                            '& .MuiDrawer-paper': {
                                boxSizing: 'border-box',
                                width: { xs: 170, md: drawerWidth },
                                backgroundImage: 'none',
                            },
                        }}
                    >
                        {matchDownXS && <img src={logoSmall} alt="small logo" width={50} height={50} /> }
                        {open && drawerContent}
                    </Drawer>
                </>
            )}
        </Box>
    );
};

MainDrawer.propTypes = {
    open: PropTypes.bool,
    handleDrawerToggle: PropTypes.func,
    window: PropTypes.object,
    showBanner: PropTypes.bool
};

export default MainDrawer;
